import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import axios from "axios";
import VueAxios from "vue-axios";
import locale from "element-ui/lib/locale/lang/en";
import VueQuillEditor from "vue-quill-editor";
import vClickOutside from "v-click-outside";
import "element-ui/lib/theme-chalk/index.css";
import "codemirror/lib/codemirror.css";

import router from "./router";
import store from "./store";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEnvelope,
  faTasks,
  faChartBar,
  faCogs
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faEnvelope);
library.add(faTasks);
library.add(faChartBar);
library.add(faCogs);

// Styles
import "./styles/app.css";

Vue.use(ElementUI, { locale });
Vue.use(VueQuillEditor);
Vue.use(VueAxios, axios);
Vue.use(vClickOutside);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.prototype.$docs = "https://s3-us-west-2.amazonaws.com/hvullc.com/docs/";
Vue.prototype.$mainServer = "https://canvas.mathsmithllc.com/";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
